import * as actions from './actions';
import type { StudyState } from './state';
import * as mutations from './mutations';
import { SafeAny } from '@/common/types';

export const studyStore = {
  namespaced: true,
  state: {
    ids: {
      isLoading: false,
      data: []
    },
    config: {
      isLoading: false
    },
    hypnogram: {
      isLoading: false
    }
  } as StudyState,
  actions,
  mutations,
  getters: {
    isStudyDataLoaded(state: SafeAny): boolean {
      return !!state.config.data?.config;
    }
  }
};
